import { eAtlas, eManulSortLayerDrawOrder, eModelAsset, eSfxSprite, eTextures, Game, rnd2 } from "../../Game";
import { BezierCurve } from "../../Utils/BezierCurve";
import { Pool } from "../../Utils/Collections/Pool";
import { ePhysicsObjects as eStadiumPhysxObjects, Stadium } from "../Stadium/Stadium";
import { eGameplayState, Gameplay, TIMER } from "../Gameplay";
import { eRoundMngState, RoundManager } from "../Round/RoundManager";
import { TargetManager } from "../Targets/TargetManager";
import { BallTail } from "./BallTail";
import { Shooter } from "./Shooter";
import { BallKickOffMark } from "./BallKickOffMark";
import { eTargetType } from "../Targets/TargetType";
import { AtlasUtils } from "../../Utils/Atlas/AtlasUtils";
import { TargetBase } from "../Targets/Targets/Target";
import { SwitchPosTargetSettings } from "../Targets/Controllers/SwitchPosController";
import { TextPopup } from "../TextPopup";



export const enum eBallState {
    /**
     * Mic ceka na vykopnuti
     */
    idle,
    /**
     * Byl spusten odpocet do vykopnuti
     */
    waitForKickOff,
    /**
     * Rizeny let mice (let do doby nez mic narazi nebo protne osu Z na urovni brany)
     */
    controlledFlight,
    /**
     * Nerizeny let mice
     */
    uncontrolledFlight,
}



/**
 * Vysledky vykopnuti
 */
export const enum eKickOffResult {
    none,
    miss,
    goal,
    target,
    goalie
}



export interface KickOffSetup {
    /**
     * Primy smer od pozice vykopnuti do cilove pozice na urovni Z brany v radianech
     */
    directAngle: number;
    /**
     * Sila vykopnuti 0 az 1
     */
    forwardPower: number;
    /**
     * Sila na ose Y (nahoru)
     */
    upPower: number;
    /**
     * Nastaveni zakriveni
     */
    bend?: KickOffBend
}



export class KickOffBend {
    /**
     * Smer zakriveni od primky start <-> cil (0 = zadne zakriveni, -1 = vlevo od prijky start <-> cil, 1 = vpravo od prijmky start <-> cil)
     */
    dir: number;
    /**
     * Vyska vrcholu zakriveni. Jedna se o pomer vysky vrcholu zakriveni vuci delce primky start <-> cil.
     */
    vertexHeight: number;
    /**
     * Offset vrcholu zakriveni na prijmce start <-> cil 0 az 1 (0 = kickoff pozice, 1 = pozice pruniku branou)
     */
    vertexOffset: number;
}



export class KickOffResEstimate {
    /**
     * Odhadovana pozice mice v momentu protnuti osy Z brany
     */
    goalPos = new pc.Vec3();
    /**
     * Odhad casu, kdy mic dosahne brany
     */
    goalTime: number;
    /**
     * Odhadovana pozice mice v momentu protnuti osy Z brankare
     */
    goaliePos = new pc.Vec3();
    /**
     * Odhad casu, kdy mic protne osu Z brankare v ms
     */
    goalieTime: number;
    /**
     * Predpokladany vysledek
     */
    result: eKickOffResult;
}



/**
 * Vypocet rychlost vykopnuti na ose Y podle vzdalenosti mice od brany
 */
/*class KickOffYSpeedSettings {
    private _minDis: number;
    private _maxDis: number;
    private _minSpeed: number;
    private _maxSpeed: number;
    private _minSpeedDisScale: number;
    private _maxSpeedDisScale: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(minDis: number, maxDis: number, minSpeed: number, maxSpeed: number, minSpeedDisScale: number, maxSpeedDisScale: number) {
        this._minDis = minDis;
        this._maxDis = maxDis;
        this._minSpeed = minSpeed;
        this._maxSpeed = maxSpeed;
        this._minSpeedDisScale = minSpeedDisScale;
        this._maxSpeedDisScale = maxSpeedDisScale;
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci odchylku od min/max vzdalenosti, pro kterou je nastaveni urceno. Pokud 0, tak je vzdalenost mezi min a max.
     * @param ballDis 
     * @returns 
     */
//-------------------------------------------------------------------------
/*    getDisDeviation(ballDis: number): number {
        if (ballDis >= this._minDis && ballDis <= this._maxDis)
            return 0;

        if (ballDis < this._minDis)
            return this._minDis - ballDis;

        return ballDis - this._maxDis;
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci rychlost vykopnuti na ose Y
     * @param ballDis Vzdalenost mice od bodu pruniku s branou
     * @param upPower Sila vykopnuti (0 = zem, 1 = horni okraj brany)
     * @returns 
     */
//-------------------------------------------------------------------------
/*    getSpeedY(ballDis: number, upPower: number): number {
        // Vypocitat min a max silu vykopu podle vzdalenosti mice od brany
        let disRatio = (ballDis - this._minDis) / (this._maxDis - this._minDis);
        let min = this._minSpeed + (this._minSpeed * this._minSpeedDisScale * disRatio);
        let max = this._maxSpeed + (this._maxSpeed * this._maxSpeedDisScale * disRatio);

        // Nastavit vektor pro Y
        return min + upPower * (max - min);
    }
}*/
class KickOffYSpeedSettings {
    private _minDis: number;
    private _maxDis: number;
    private _minDisSpeed0: number;
    private _minDisSpeed1: number;
    private _maxDisSpeed0: number;
    private _maxDisSpeed1: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(minDis: number, maxDis: number, minDisSpeed0: number, minDisSpeed1: number, maxDisSpeed0: number, maxDisSpeed1: number) {
        this._minDis = minDis;
        this._maxDis = maxDis;
        this._minDisSpeed0 = minDisSpeed0;
        this._minDisSpeed1 = minDisSpeed1;
        this._maxDisSpeed0 = maxDisSpeed0;
        this._maxDisSpeed1 = maxDisSpeed1;
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci odchylku od min/max vzdalenosti, pro kterou je nastaveni urceno. Pokud 0, tak je vzdalenost mezi min a max.
     * @param ballDis
     * @returns
     */
    //-------------------------------------------------------------------------
    getDisDeviation(ballDis: number): number {
        if (ballDis >= this._minDis && ballDis <= this._maxDis)
            return 0;

        if (ballDis < this._minDis)
            return this._minDis - ballDis;

        return ballDis - this._maxDis;
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci rychlost vykopnuti na ose Y
     * @param ballDis Vzdalenost mice od bodu pruniku s branou
     * @param upPower Sila vykopnuti (0 = zem, 1 = horni okraj brany)
     * @returns
     */
    //-------------------------------------------------------------------------
    getSpeedY(ballDis: number, upPower: number): number {
        // Vypocitat min a max silu vykopu podle vzdalenosti mice od brany
        let disRatio = (ballDis - this._minDis) / (this._maxDis - this._minDis);
        //let min = this._minDisSpeed + (this._minDisSpeed * this._minSpeedDisScale * disRatio);
        //let max = this._maxDisSpeed + (this._maxDisSpeed * this._maxSpeedDisScale * disRatio);
        let min = this._minDisSpeed0 + (this._maxDisSpeed0 - this._minDisSpeed0) * disRatio;
        let max = this._minDisSpeed1 + (this._maxDisSpeed1 - this._minDisSpeed1) * disRatio;

        // Nastavit vektor pro Y
        return min + upPower * (max - min);
    }
}


export class Ball {
    /**
     * Udalost vyvolana po vykopnuti mice
     * Emitter: Gameplay.events
     * Parametry:
     * resEstimate: KickOffResEstimate     
     */
    static readonly EVENT_KICKED_OFF1 = "ball:kickedOff1";
    /**
     * Udalost vyvolana po zahajeni letu mice
     * Emitter: Gameplay.events
     * Parametry:
     * resEstimate: KickOffResEstimate
     * 
     */
    static readonly EVENT_KICKED_OFF2 = "ball:kickedOff2";
    /**
     * Udalost vyvolana pote vysledek letu mice
     * Emitter: Gameplay.events
     * Parametry:
     * res: eKickOffResult
     */
    static readonly EVENT_FLIGHT_END = "ball:kickOffEnd";
    /**
     * Udalost vyvolana pri zmene stavu golden ballu
     * Parametry:
     * state: 0 az 1
     */
    static readonly EVENT_FIRE_BALL_STATE_CHANGE = "ball:goldenChange";
    /**
     * Polomer mice
     */
    static readonly RADIUS = 0.12;

    static readonly FIREBALL_COLOR = new pc.Color().fromString("#ff0000");

    static get instance(): Ball { return Ball._instance; }
    private static _instance: Ball;

    get entity(): pc.Entity { return this._entity; }
    private _entity: pc.Entity;

    private static readonly FIREBALL_FRAME_TIME = 1000 / 25;

    private _fireBallEnt: pc.Entity;
    private _fireBallMat: pc.StandardMaterial;
    private _fireBallAnimTime: number;
    private _fireBallFrameRect: pc.Vec4;
    private _fireBallFrameId: number;
    private _fireBallGlow: pc.GraphNode;

    get state(): eBallState { return this._state; }
    private _state: eBallState;

    private _stateProcessFnc: (() => void)[];

    /**
     * Rychlost vykopnuti v units per second
     */
    private _kickOffSpeed: number;
    /**
     * (RO) Odhadovany vysledek vykopnuti mice
     */
    get kickOffResEstimate(): KickOffResEstimate { return this._kickOffResEstimate; }
    private _kickOffResEstimate: KickOffResEstimate;
    /**
     * (RO) Finalni vysledek vykopnuti
     */
    get kickOffFinalRes(): eKickOffResult { return this._kickOffFinalRes; }
    private _kickOffFinalRes: eKickOffResult;

    /**
     * Pozice mice pri vykopnuti
     */
    get kickOffPos(): pc.Vec3 { return this._kickOffPos; }
    private _kickOffPos: pc.Vec3 = new pc.Vec3();
    /**
     * (RO) Cas vykopnuti (ms)
     * Pocita se od skutecneho zahajeni letu mice
     */
    get kickOffTime(): number { return this._kickOffTime; }
    private _kickOffTime: number;
    /**
     * (RO) Aktualni unit move vector. Aktualizuje se behem letu podle skutecne linearVelocity.
     */
    get moveVector(): pc.Vec3 { return this._moveVector; }
    private _moveVector = new pc.Vec3();
    private _kickOffMoveVector = new pc.Vec3();
    /**
     * Aktualni rychlost pohybu mice (squared)
     */
    private _moveSpeedSq: number;
    /**
     * True, pokud byla detekovana kolize s vnitrkem brany
     */
    private _goalReached: boolean;

    /**
     * Rychlost letu mice (behem letu se nemeni)
     */
    private static readonly MAX_SPEED = 25 * 0.8;
    private static readonly MIN_SPEED = 15;

    private _kickOffYSpeedSettings: KickOffYSpeedSettings[] = [
        new KickOffYSpeedSettings(13, 18, 2.36, 6.4, 3.4, 6.5),
        new KickOffYSpeedSettings(18, 23, 3.4, 6.5, 4.6, 7.15),
        new KickOffYSpeedSettings(23, 28, 4.6, 7.15, 5.8, 8.05)
    ];

    /*
    private static readonly KICKOFF_MIN_Y_SPEED = 4;
    private static readonly KICKOFF_MAX_Y_SPEED = 6.6;    

    private static readonly KICKOFF_Y_SET_A_DISTANCE = 20;
    private static readonly KICKOFF_Y_SET_B_DISTANCE = 30;
    private static readonly KICKOFF_Y_SET_B_RATIO_FOR_MIN = 0.58;
    private static readonly KICKOFF_Y_SET_B_RATIO_FOR_MAX = 0.245;*/

    /**
     * Vektor vykopu po prijmce start <-> cil
     */
    private _kickOffLineVec = new pc.Vec3();
    /**
     * Nastaveni zakriveni vykopu
     */
    private _kickOffBend: KickOffBend;
    /**
     * Nastaveni krivky letu mice
     */
    private _curve: BezierCurve;
    /**
     * Aktualni pozice na krivce v rozsahu 0 az 1
     */
    private _curveT: number;
    /**
     * Zmena T krivky za vterinu. Pokud 0, tak se mic nepohybuje po krivce, ale po primce.
     */
    private _curveTStep: number;
    /**
     * Vrcholy pro ocas
     */
    private _tail: BallTail;
    /**
     * Oznaceni mista vykopu
     */
    private _kickOffMark: BallKickOffMark;

    private _markMat: pc.StandardMaterial;
    private _freeMarks: Pool<pc.Entity>;
    private _actMarks: pc.Entity[];

    //private static readonly WIND_MIN_FORCE = 0.04;
    //private static readonly WIND_MAX_FORCE = 0.1;
    /**
     * Aktualni rychlost vetru za vterinu
     */
    //private _windVelocity: number;
    /**
     * Zmena rychlosti vetru za vterinu
     */
    //private _windVelocityChange: number;
    /**
     * (RO) True, pokud je mozne mic vykopnout
     */
    get isKickOffReady(): boolean {
        return this._state == eBallState.idle && Gameplay.instance.state == eGameplayState.play && RoundManager.instance.state == eRoundMngState.playRound && !Game.paused;
    }
    /**
     * (RO) Stav "FIRE BALL". 0 az 1, pokud 1, tak je fire ball.
     */
    get fireBallState(): number { return this._fireBallState; }
    private _fireBallState: number;

    /**
     * Je golden ball
     */
    private static readonly FLAG_FIRE_BALL = 0x0001;

    private _flags: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        Ball._instance = this;

        // Flagy
        this._flags = 0;
        this._fireBallState = 0;

        // Zpracovani jendotlivych stavu mice
        this._stateProcessFnc = [];
        this._stateProcessFnc[eBallState.waitForKickOff] = this.processWaitForKickOff;
        this._stateProcessFnc[eBallState.controlledFlight] = this.processControlledFlight;
        this._stateProcessFnc[eBallState.uncontrolledFlight] = this.processUncontrolledFlight;

        // Entita mice
        this._entity = new pc.Entity(eStadiumPhysxObjects.ball);
        this._entity.addComponent(pc.eCompomentType.model, {
            type: pc.eModelType.asset,
            asset: Game.app.assets.find(eModelAsset.ball, pc.eAssetType.model),
            castShadows: true,
            receiveShadows: true,
        });
        this._entity.setLocalScale(1.06, 1.06, 1.06);
        Game.app.root.addChild(this._entity);

        // Fyzika mice
        this._entity.addComponent(pc.eCompomentType.rigidbody, {
            type: pc.BODYTYPE_DYNAMIC,
            mass: 0.4,
            restitution: 0.6,
            friction: 0.6,
            angularDamping: 0.75,
            linearDamping: 0,
        });

        this._entity.addComponent(pc.eCompomentType.collision, {
            type: pc.eCollisionVolumeType.sphere,
            radius: Ball.RADIUS
        });

        this._entity.collision.on("collisionstart", this.handleCollisionStart, this);
        this._entity.collision.on("triggerenter", this.handleTriggerEnter, this);

        // Fireball efekt
        this.createFireBallFx();

        // Odhad vysledku vykopnuti
        this._kickOffResEstimate = new KickOffResEstimate();

        // Krivka letu mice
        this._curve = new BezierCurve();

        // Ocas
        this._tail = new BallTail();

        // Oznaceni mista vykopu
        this._kickOffMark = new BallKickOffMark(this);

        // Znacky
        this._markMat = new pc.StandardMaterial();

        this._markMat.diffuse.set(1, 0, 0);
        this._markMat.update();

        this._freeMarks = new Pool<pc.Entity>(undefined, 5, true, (): pc.Entity => {
            let mark = new pc.Entity();

            mark.addComponent(pc.eCompomentType.model, {
                type: pc.eModelType.sphere,
                material: this._markMat,
                castShadows: false,
                receiveShadows: false,
                static: false
            });
            mark.enabled = false;
            mark.setLocalScale(0.25, 0.25, 0.25);
            Game.app.root.addChild(mark);

            return mark;
        });
        this._actMarks = [];
    }

    //-------------------------------------------------------------------------
    /**
     * Pripravit mic na vykopnuti
     */
    //-------------------------------------------------------------------------
    prepareKickOff(): void {
        let rs = RoundManager.instance.roundSetup;

        // Umistit mic
        let body = this._entity.rigidbody;

        body.linearVelocity = body.linearVelocity.set(0, 0, 0);
        body.angularVelocity = body.angularVelocity.set(0, 0, 0);
        body.teleport(rs.kickOffPos);

        // Zlaty nebo normlani mic
        if (this._fireBallState != 1) {
            if ((this._flags & Ball.FLAG_FIRE_BALL) != 0) {
                // Prepnout na obycejnej mic
                this._flags &= ~Ball.FLAG_FIRE_BALL;

                /*let mat = this._entity.model.meshInstances[0].material as pc.StandardMaterial;

                mat.diffuseMap = Game.app.assets.find(eTextures.normalBall, pc.eAssetType.texture).resource;
                mat.update();*/

                this._fireBallEnt.enabled = false;
                this._fireBallGlow.enabled = false;
            }
        }
        else if ((this._flags & Ball.FLAG_FIRE_BALL) == 0) {
            // Prepnout na Golden Ball
            this._flags |= Ball.FLAG_FIRE_BALL;

            /*let mat = this._entity.model.meshInstances[0].material as pc.StandardMaterial;

            mat.diffuseMap = Game.app.assets.find(eTextures.goldenBall, pc.eAssetType.texture).resource;
            mat.update();*/

            this._fireBallEnt.enabled = true;
            this._fireBallGlow.enabled = true;
        }

        this._kickOffPos.copy(rs.kickOffPos);
        this._kickOffFinalRes = eKickOffResult.none;
        this._goalReached = false;
        this._state = eBallState.idle;

        // Vitr
        /*let windPower = rs.wind;

        this._windVelocity = 0;
        this._windVelocityChange = 0;

        if (windPower != 0) {
            this._windVelocityChange = Ball.WIND_MIN_FORCE + ((Ball.WIND_MAX_FORCE - Ball.WIND_MIN_FORCE) / (RoundSetup.WIND_MAX_POWER - 1)) * (Math.abs(windPower) - 1);

            if (windPower < 0)
                this._windVelocityChange *= -1;
        }*/

        // Ocas
        this._tail.reset();

        // Oznaceni mista vykopu
        this._kickOffMark.init();

        this.clearMarks();
    }

    //-------------------------------------------------------------------------
    /**
     * Vykopnuti mice
     * @param directAngle 
     * @param forwardPower 
     * @param upPower 0 = kop u zeme, 1 = kop do horniho okraje brany
     * @param bend 
     */
    //-------------------------------------------------------------------------
    kickOff(directAngle: number, forwardPower: number, upPower: number, bend?: KickOffBend): void {
        //directAngle = (-57.3 * pc.math.DEG_TO_RAD);
        //upPower = 0.5;

        // Cas vykopnuti
        this._kickOffTime = TIMER.time + Shooter.BALL_KICKOFF_TIME_OFFSET * 1000;

        // Rychlost vykopnuti
        this._kickOffSpeed = Ball.MIN_SPEED + (Ball.MAX_SPEED - Ball.MIN_SPEED) * forwardPower;

        // Validovat uhel prijmky start <-> cil do urcitych mezi
        directAngle = this.validateKickOffDir(directAngle);

        // Jendotkovy vektor pro smer pohybu po primce start <-> cil 
        this._kickOffLineVec.set(Math.cos(directAngle), 0, Math.sin(directAngle));

        // Pozice pruniku mice branou na ose X
        this.getBallIntersectPosX(Stadium.GOAL_Z + Ball.RADIUS, this._kickOffResEstimate.goalPos);

        // Delka prijmky start <-> cil
        let goalDirPathLen = Math.sqrt(Math.pow(this._kickOffPos.x - this._kickOffResEstimate.goalPos.x, 2) + Math.pow(this._kickOffPos.z - this._kickOffResEstimate.goalPos.z, 2));

        // Vypocitat vektor vykopu na Y
        this.calcKickOffVecY(upPower, goalDirPathLen);

        // Pozice pruniku mice branou na ose Y (nyni jiz zname vektor na Y)
        this.getBallIntersectPosY(Stadium.GOAL_Z + Ball.RADIUS, this._kickOffResEstimate.goalPos);
        this.showMark(this._kickOffResEstimate.goalPos);

        // Delka cesty mice nez protne osu Z brankare/brany
        let goaliePathLen: number;
        let goalPathLen: number;

        if (!bend || bend.dir == 0) {
            // Pohyb po primce
            this._curveTStep = 0;

            // Pozice pruniku mice na urovni brankare
            this.getBallIntersectPosX(Stadium.GOALIE_DEFEND_Z + Ball.RADIUS, this._kickOffResEstimate.goaliePos);
            this.getBallIntersectPosY(Stadium.GOALIE_DEFEND_Z + Ball.RADIUS, this._kickOffResEstimate.goaliePos);

            // Delka cesty mice nez protne osu Z brankare
            goaliePathLen = this._kickOffPos.distance(this._kickOffResEstimate.goaliePos);
            goalPathLen = this._kickOffPos.distance(this._kickOffResEstimate.goalPos);
        }
        else {
            this._kickOffBend = bend;

            // Prvni a posledni bod krivky
            this._curve.p1.set(this._kickOffPos.x, this._kickOffPos.z);
            this._curve.p3.set(this._kickOffResEstimate.goalPos.x, this._kickOffResEstimate.goalPos.z);

            // Pozice vrcholu na primce start <-> cil
            let bendVertexLineOffset = goalDirPathLen * Math.min(0.8, Math.max(0.2, bend.vertexOffset));

            // Vypocitat vzdalenost vrcholu zakriveni od primky start <-> cil
            let bendVertexHeight = Math.min(0.4, bend.vertexHeight) * goalDirPathLen;

            // Vypocitat pozici vrcholu zakriveni
            let dir = directAngle + (Math.PI / 2) * bend.dir;
            let bendVertexX = (this._kickOffPos.x + this._kickOffLineVec.x * bendVertexLineOffset) + Math.cos(dir) * bendVertexHeight;
            let bendVertexZ = (this._kickOffPos.z + this._kickOffLineVec.z * bendVertexLineOffset) + Math.sin(dir) * bendVertexHeight;

            // Vypocitat pozici stredu na primce start <-> cil
            let lineCenterX = this._kickOffPos.x + this._kickOffLineVec.x * (goalDirPathLen / 2);
            let lineCenterZ = this._kickOffPos.z + this._kickOffLineVec.z * (goalDirPathLen / 2);

            // Ziskat smer ze stredu primky do vrcholu zakriveni
            dir = Math.atan2(bendVertexZ - lineCenterZ, bendVertexX - lineCenterX);

            // Ziskat vzdalenost vrcholu zakriveni od stredu primky
            bendVertexHeight = Math.sqrt(Math.pow(bendVertexX - lineCenterX, 2) + Math.pow(bendVertexZ - lineCenterZ, 2));

            // Vypocitat P2 pro bezierovu krivku (vzdalenost od vrcholu zakriveni jako vzdalenost vrcholu od stredu a ve stejnem smeru od )
            bendVertexHeight *= 0.3;  // Upravit vzdalenost, aby krivka byla min prohnuta nez jak ji nakreslil hrac
            this._curve.p2.x = lineCenterX + Math.cos(dir) * bendVertexHeight;
            this._curve.p2.y = lineCenterZ + Math.sin(dir) * bendVertexHeight;

            // Vykreslit krivku
            /*for (let i = 1; i < 20; i++) {
                let pos = this._curve.getPos(i / 20);

                this.showMark(pos.x, 0, pos.y);
            }*/

            // Vypocitat delku krivky
            goalPathLen = this._curve.getLength();

            // Vypocitat krok pohybu po krivce za vterinu
            this._curveTStep = 1 / (goalPathLen / this._kickOffSpeed);

            // Vypocitat pozici mice na Y pri dokonceni krivky
            this._kickOffResEstimate.goalPos.y = this.getGravityResPos(Ball.RADIUS, Math.asin(this._kickOffLineVec.y), goalPathLen);

            // Nastavit move vector
            this._curveT = (this._curveTStep * TIMER.deltaS) * 4;

            // Pozice pruniku mice na urovni brankare
            // Hledat T pro bezier krivku, pri kterem je mic tesne pred pozici Z, na ktere ho muze brankar chytnout
            let y1 = this._curve.p1.y;
            let y2 = this._curve.p2.y;
            let y3 = this._curve.p3.y;

            for (let t = 1 - 0.001; t > 0; t -= 0.001) {
                if (Math.pow(1 - t, 2) * y1 + 2 * (1 - t) * t * y2 + Math.pow(t, 2) * y3 >= Stadium.GOALIE_DEFEND_Z + Ball.RADIUS) {
                    let pos = this._curve.getPos(t);

                    goaliePathLen = goalPathLen * t;

                    this._kickOffResEstimate.goaliePos.x = pos.x;
                    this._kickOffResEstimate.goaliePos.z = pos.y;
                    this._kickOffResEstimate.goaliePos.y = this.getGravityResPos(Ball.RADIUS, Math.asin(this._kickOffLineVec.y), goaliePathLen);

                    break;
                }
            }
        }

        // V jakem case se mic dostane do intersect pozice brankare
        this._kickOffResEstimate.goalieTime = this._kickOffTime + (goaliePathLen / this._kickOffSpeed) * 1000;
        this._kickOffResEstimate.goalTime = this._kickOffTime + (goalPathLen / this._kickOffSpeed) * 1000;

        // Zasahne mic cil?
        let ballPos2D = new pc.Vec2(this._kickOffResEstimate.goalPos.x, this._kickOffResEstimate.goalPos.y);

        this._kickOffResEstimate.result = eKickOffResult.miss;

        TargetManager.instance.actTargets.every((target: TargetBase): boolean => {
            if (target.settings.type != eTargetType.fireRing) {
                if (target.checkKickOffResult(this._kickOffResEstimate.goalTime, ballPos2D)) {
                    this._kickOffResEstimate.result = eKickOffResult.target;
                    return false;
                }
            }

            return true;
        });

        // Prvni vrchol ocasu
        this._tail.addVertex(this._kickOffPos);

        this._state = eBallState.waitForKickOff;
        Gameplay.instance.events.fire(Ball.EVENT_KICKED_OFF1, this._kickOffResEstimate, directAngle, upPower);
    }

    private vec = new pc.Vec3(0, 0, 1);

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        this._kickOffMark.update();

        let fnc = this._stateProcessFnc[this._state];

        if (fnc)
            fnc.call(this);

        // Fireball
        if (this._fireBallEnt.enabled) {
            this._fireBallEnt.setPosition(this._entity.getPosition());
            this._fireBallEnt.rotateLocal(0, 0, 1);

            if (this._fireBallAnimTime <= TIMER.time)
                this.animFireBall();

            this._fireBallGlow.setRotation(Game.camera.getRotation());

        }

        if (this._state == eBallState.controlledFlight || this._state == eBallState.uncontrolledFlight) {
            // Aktualni rychlost letu mice
            this._moveSpeedSq = this._entity.rigidbody.linearVelocity.lengthSq();

            // Ocas
            if (this._moveSpeedSq < 80)
                this._tail.hide();

            this._tail.addVertex(this._entity.getPosition());
            this._tail.update();

            // Overit konec letu
            this.checkFlightEnd();
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    incFireBallState(): void {
        if (this._fireBallState != 1) {
            this._fireBallState += 1 / 3;

            if (this._fireBallState > 0.99)
                this._fireBallState = 1;

            Gameplay.instance.events.fire(Ball.EVENT_FIRE_BALL_STATE_CHANGE, this._fireBallState);
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Odrazeni mice od brankare
     */
    //-------------------------------------------------------------------------
    bounceOffGoalie(): void {
        if (this._kickOffFinalRes > eKickOffResult.miss)
            return;

        // Vypocitat vektor odrazu
        /*let bounceVec = new pc.Vec3().copy(Goalie.BALL_REFLECT_NORMAL_VEC);

        bounceVec.mulScalar(-2 * this._moveVector.dot(bounceVec)).add(this._moveVector);*/
        let bounceVec = new pc.Vec3().copy(this._moveVector);

        //bounceVec.x *= 4;
        bounceVec.z *= -1;

        // Aktualni rychlost letu
        let speed = this._entity.rigidbody.linearVelocity.length();

        // Zmenit vektor pohybu letu mice
        this._entity.rigidbody.linearVelocity = bounceVec.mulScalar(speed * 0.2);

        // Zvuk
        Game.playSound(eSfxSprite.catch + rnd2.randomIntIn(0, 1));

        // Ukoncit zpracovani letu mice
        this.setKickOffFinalRes(eKickOffResult.goalie);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private createFireBallFx(): void {
        // Fireball efekt
        this._fireBallFrameId = -1;
        this._fireBallFrameRect = new pc.Vec4();

        this._fireBallMat = new pc.StandardMaterial();
        this._fireBallMat.emissiveMap = Game.atlas.texture;
        this._fireBallMat.blendType = pc.BLEND_NORMAL;
        this._fireBallMat.diffuse.set(0, 0, 0);
        this._fireBallMat.opacity = 0.6;
        this._fireBallMat.opacityMap = Game.atlas.texture;
        this._fireBallMat.opacityMapChannel = "a";
        this.animFireBall();

        this._fireBallEnt = new pc.Entity();
        this._fireBallEnt.addComponent(pc.eCompomentType.model, {
            type: pc.eModelType.sphere,
            castShadows: false,
            receiveShadows: false,
            material: this._fireBallMat,
            layers: [Game.manualSortLayer.id],
        });
        this._fireBallEnt.setEulerAngles(0, 0, 0);
        this._fireBallEnt.setLocalScale(0.245, 0.245, 0.245);//(0.3, 0.3, 0.3);
        this._fireBallEnt.model.meshInstances[0].drawOrder = eManulSortLayerDrawOrder.ballFireBallGlow;
        this._fireBallEnt.enabled = false;
        Game.app.root.addChild(this._fireBallEnt);

        // Zare okolo mice
        let atlas = Game.getAtlas(eAtlas.def1);
        let glowMat = new pc.StandardMaterial();
        let glowFrameRc = AtlasUtils.getAtlasFrameRegion(atlas, "fireBall/glow");

        glowMat.diffuse.set(0, 0, 0);
        glowMat.emissive.copy(Ball.FIREBALL_COLOR);
        glowMat.blendType = pc.BLEND_ADDITIVEALPHA;
        glowMat.opacityMap = atlas.texture;
        glowMat.opacity = 0.3;
        glowMat.opacityMapOffset.set(glowFrameRc.x, glowFrameRc.y);
        glowMat.opacityMapTiling.set(glowFrameRc.z, glowFrameRc.w);
        glowMat.useFog = false;
        glowMat.useSkybox = false;
        glowMat.useLighting = false;
        glowMat.depthWrite = false;
        //mat.depthTest = false;
        glowMat.update();

        let glowEnt = new pc.Entity();

        glowEnt.addComponent(pc.eCompomentType.model, {
            type: pc.eModelType.plane,
            castShadows: false,
            receiveShadows: false,
            material: glowMat
        });
        glowEnt.setLocalEulerAngles(90, 0, 0);
        glowEnt.setLocalScale(0.35, 0.35, 0.35);

        this._fireBallGlow = new pc.GraphNode();
        this._fireBallGlow.addChild(glowEnt);
        this._fireBallGlow.enabled = false;
        this._entity.addChild(this._fireBallGlow);

        /*let colorGraph1 = new pc.CurveSet([
            [0, 1, 1, 1],
            [0, 0.75, 1, 1],
            [0, 0, 1, 1]
        ]);
        colorGraph1.type = pc.CURVE_LINEAR;

        let opacityGraph = new pc.Curve([0, 0, 0.151, 1, 1, 0]);
        opacityGraph.type = pc.CURVE_SMOOTHSTEP;

        let parSysSetup = {
            numParticles: 200,
            lifetime: 1,
            rate: 0.01,
            rate2: 0.01,
            startAngle: 0,
            startAngle2: 360,
            loop: true,
            preWarm: false,
            lighting: false,
            intensity: 1,
            depthWrite: false,
            depthSoftening: 0.1,
            sort: pc.PARTICLESORT_NONE,
            blend: pc.BLEND_NONE,
            stretch: 0,
            alignToMotion: false,
            emitterShape: pc.EMITTERSHAPE_SPHERE,
            emitterRadius: 0.1,
            emitterRadiusInner: 0,
            wrap: false,
            localSpace: false,
            screenSpace: false,
            orientation: pc.PARTICLEORIENTATION_SCREEN,
            colorMap: (Game.app.assets.find(eTextures.partFireball, pc.eAssetType.texture).resource as pc.Texture),
            animTilesX: 8,
            animTilesY: 8,
            animNumFrames: 64,
            animSpeed: 1,
            velocityGraph: new pc.CurveSet([
                [0, -0.15],
                [0, 0.15],
                [0, -0.3]
            ]),
            velocityGraph2: new pc.CurveSet([
                [0, 0.15],
                [0, 0.15, 0.828, 0.5],
                [0, 0.3]
            ]),
            colorGraph: colorGraph1,
            alphaGraph: opacityGraph,
            scaleGraph: new pc.Curve([0, 0.019 * 3, 0.353, 0.094 * 3, 1, 0]),
            layers: [Game.app.scene.layers.getLayerByName("Immediate").id]
        };
        this._fireBallPartSysEnt = new pc.Entity();
        this._fireBallPartSysEnt.addComponent(pc.eCompomentType.particlesystem, parSysSetup);
        this._fireBallPartSysEnt.setPosition(0, 0.5, -40);
        Game.app.root.addChild(this._fireBallPartSysEnt);*/
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private animFireBall(): void {
        if (++this._fireBallFrameId == 16)
            this._fireBallFrameId = 0;

        this._fireBallAnimTime = TIMER.time + Ball.FIREBALL_FRAME_TIME;

        let frameRect = AtlasUtils.getAtlasFrameRegion(Game.atlas, "fireBall/fire_" + this._fireBallFrameId, this._fireBallFrameRect);

        this._fireBallMat.emissiveMapOffset.set(frameRect.x, frameRect.y);
        this._fireBallMat.emissiveMapTiling.set(frameRect.z, frameRect.w);
        this._fireBallMat.opacityMapOffset.set(frameRect.x, frameRect.y);
        this._fireBallMat.opacityMapTiling.set(frameRect.z, frameRect.w);
        this._fireBallMat.update();
    }

    //-------------------------------------------------------------------------
    /**
     * Ziskat pozici pruniku mice pro danou pozici na ose Z podle _kickOffLineVec
     * @param z 
     * @param res 
     */
    //-------------------------------------------------------------------------
    private getBallIntersectPosX(z: number, res: pc.Vec3): void {
        res.set(this._kickOffPos.x, 0, z);

        if (this._kickOffLineVec.x != 0)
            res.x -= (this._kickOffPos.z - z) / (this._kickOffLineVec.z / this._kickOffLineVec.x);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private getBallIntersectPosY(z: number, res: pc.Vec3): void {
        let dir = Math.asin(this._kickOffLineVec.y);

        // Vypocet Y na pozici Z pruniku -> y = h + x * tan(alpha) - g * x^2 / 2 * v^2 * cos(A)^2
        res.y = this.getGravityResPos(Ball.RADIUS, dir, Math.sqrt(Math.pow(res.x - this._kickOffPos.x, 2) + Math.pow(res.z - this._kickOffPos.z, 2)));
    }

    //-------------------------------------------------------------------------
    /**
     * Vypocitat pozici Y po urcite vzdalenosti pri aplikovani gravitace
     * @param startPos Pocatecni pozice na ose Y
     * @param startAngle Pocetni uhel na ose Y
     * @param dis Vzdalenost, za kterou chceme znat pozice na ose Y   
     * @returns 
     */
    //-------------------------------------------------------------------------
    private getGravityResPos(startPos: number, startAngle: number, dis: number): number {
        let pos = startPos + (dis * Math.tan(startAngle)) - (-Game.GRAVITY_Y * Math.pow(dis, 2)) / (2 * Math.pow(this._kickOffSpeed, 2) * Math.pow(Math.cos(startAngle), 2));

        if (pos < Ball.RADIUS)
            pos = Ball.RADIUS;

        return pos;
    }

    //-------------------------------------------------------------------------
    /**
     * Vypocitat unit vektor vykopnuti pro osu Y
     * @param upPower 0 = kop u zeme, 1 = kop do horniho okraje brany
     * @param goalDirPathLen Delka prijmky od mista vykopnuti do mista pruniku mice branou (po zemi)
     */
    //-------------------------------------------------------------------------
    private calcKickOffVecY(upPower: number, goalDirPathLen: number): void {
        // Max do 1.5x vysky brany
        if (upPower > 1.5)
            upPower = 1.5;

        // Aktualni unit vector prevest na vektor s celkovou hodnotou podle rychlosti vykopu
        this._kickOffLineVec.mulScalar(this._kickOffSpeed);

        // Rychlost vykopu na ose Y podle vzdalenosti mice od brany

        // Najit nastaveni, podle ktereho se nastavi sila
        let setDeviations: number[] = [];
        let setId = -1;

        for (let i = 0; i < this._kickOffYSpeedSettings.length; i++) {
            if ((setDeviations[i] = this._kickOffYSpeedSettings[i].getDisDeviation(goalDirPathLen)) == 0) {
                setId = i;
                break;
            }
        }

        if (setId < 0) {
            // Vybrat nastaveni s nejmensi odchylkou
            let setMinDev = Number.MAX_SAFE_INTEGER;

            for (let i = 0; i < this._kickOffYSpeedSettings.length; i++) {
                if (setDeviations[i] < setMinDev) {
                    setMinDev = setDeviations[i];
                    setId = i;
                }
            }
        }

        // Nastavit vektor pro Y
        this._kickOffLineVec.y = this._kickOffYSpeedSettings[setId].getSpeedY(goalDirPathLen, upPower);

        // Prevest na unit vector
        this._kickOffLineVec.normalize();
    }

    //-------------------------------------------------------------------------
    /**
     * Pohybuje micem po krivce
     * @param velocityY Velocity na ose Y, ktera se ma pouzit. Pokud nezadano, tak se velocity na Y nezmeni.
     */
    //-------------------------------------------------------------------------
    private moveBallAlongCurve(velocityY?: number): void {
        this._curveT += this._curveTStep * TIMER.deltaS;

        if (this._curveT >= 1) {
            // Ukoncit rizeny let
            this._curveT = 1;
            this._state = eBallState.uncontrolledFlight;
        }

        let curPos = this._entity.getPosition();
        let tarPos = this._curve.getPos(this._curveT);
        let dir = Math.atan2(tarPos.y - curPos.z, tarPos.x - curPos.x);

        this._moveVector.set(Math.cos(dir) * this._kickOffSpeed,
            velocityY == undefined ? this._entity.rigidbody.linearVelocity.y : velocityY,
            Math.sin(dir) * this._kickOffSpeed);

        this._entity.rigidbody.linearVelocity = this._moveVector;
        this._moveVector.normalize();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private processWaitForKickOff(): void {
        if (TIMER.time < this._kickOffTime)
            return;

        Game.playSound(eSfxSprite.kick + rnd2.randomIntIn(0, 2));

        // Vykopnout mic
        if (this._curveTStep == 0) {
            // Primy let
            this._moveVector.copy(this._kickOffLineVec).mulScalar(this._kickOffSpeed);
            this._kickOffMoveVector.copy(this._moveVector);
            this._entity.rigidbody.linearVelocity = this._moveVector;
            this._entity.rigidbody.angularVelocity = this._entity.rigidbody.angularVelocity.set(10, 0, 0);
            this._moveVector.copy(this._kickOffLineVec);
        }
        else {
            // Zakriveny let
            this.moveBallAlongCurve(this._kickOffLineVec.y * this._kickOffSpeed);
            this._entity.rigidbody.angularVelocity = new pc.Vec3(10, (10 + 15 * Math.min(0.4, this._kickOffBend.vertexHeight) / 0.4) * this._kickOffBend.dir, 0);
        }

        this._state = eBallState.controlledFlight;
        Gameplay.instance.events.fire(Ball.EVENT_KICKED_OFF2, this._kickOffResEstimate);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private processControlledFlight(): void {
        //if (this._windVelocityChange != 0)
        //    this._windVelocity += this._windVelocityChange * TIMER.deltaRatio;

        if (this._curveTStep != 0) {
            // Pohyb po krivce
            this.moveBallAlongCurve();
        }
        else {
            this._moveVector.copy(this._entity.rigidbody.linearVelocity);

            /*if (this._windVelocity != 0) {
                this._moveVector.x = this._kickOffMoveVector.x + this._windVelocity;
                this._entity.rigidbody.linearVelocity = this._moveVector;
            }*/

            this._moveVector.normalize();

            //this._moveVector.copy(this._entity.rigidbody.linearVelocity).normalize();
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private processUncontrolledFlight(): void {
        // Ziskat jednotkovy smerovy vektor
        this._moveVector.copy(this._entity.rigidbody.linearVelocity).normalize();
    }

    //-------------------------------------------------------------------------
    /**
     * Overit zda mic nedokoncil svuj let
     */
    //-------------------------------------------------------------------------
    private checkFlightEnd(): void {
        if (this._kickOffFinalRes == eKickOffResult.none) {
            // Pokud se mic dostane za branu nebo uplne mimo
            let ballPos = this._entity.getPosition();

            if (ballPos.z < Stadium.END_Z - 3 || ballPos.x < -12 || ballPos.x > 12) {
                this.setKickOffFinalRes(eKickOffResult.miss);
            }
            // Pokud rychlost mice klesne pod min hodnotu
            else if (this._moveSpeedSq < 25) {
                this.setKickOffFinalRes(eKickOffResult.miss);
            }
            // Pokud aktualni vektor pohybu mice je prilis jiny nez smer vykopnuti
            /*else if (this._kickOffLineVec.dot(this._moveVector) < 0.25) {
                this.setKickOffFinalRes(eKickOffResult.miss);
            }*/
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Validace smeru vykopu. Zabrani vykopu prilis mimo branu (vlevo/vpravo)
     * @param dir 
     * @returns 
     */
    //-------------------------------------------------------------------------
    private validateKickOffDir(dir: number): number {
        const rs = RoundManager.instance.roundSetup;
        const goalLSideAngle = rs.goalLSideAngle * pc.math.RAD_TO_DEG;
        const goalRSideAngle = rs.goalRSideAngle * pc.math.RAD_TO_DEG;
        const dirLimit = 10;

        dir *= pc.math.RAD_TO_DEG;

        if (dir < 0) {
            if (dir < goalLSideAngle - dirLimit) {
                dir = goalLSideAngle - dirLimit;
            }
            else if (dir > goalRSideAngle + dirLimit) {
                dir = goalRSideAngle + dirLimit;
            }
        }
        else if (dir > 90) {
            dir = goalLSideAngle - dirLimit;
        }
        else {
            dir = goalRSideAngle + dirLimit;
        }

        return dir * pc.math.DEG_TO_RAD;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleCollisionStart(res: pc.ContactResult): void {
        // Jakmile nastane kolize s jinym objektem, tak ukoncit rizeny let      
        switch (res.other.name) {
            case eStadiumPhysxObjects.goalBar: {
                if (this._state == eBallState.controlledFlight)
                    Game.playSound(eSfxSprite.postHit);

                break;
            }
            case eStadiumPhysxObjects.defender: {
                Game.playSound(eSfxSprite.catch + rnd2.randomIntIn(0, 1));
                break;
            }
        }

        if (this._state == eBallState.controlledFlight)
            this._state = eBallState.uncontrolledFlight;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleTriggerEnter(other: pc.Entity): void {
        if (other.name == eStadiumPhysxObjects.goalTrigger && this._kickOffFinalRes == eKickOffResult.none) {
            if (!this._goalReached) {
                this._goalReached = true;

                if (TargetManager.instance.evaluateHits()) {
                    this.setKickOffFinalRes(eKickOffResult.target);
                }
                else {
                    let gameplay = Gameplay.instance;

                    if (gameplay.state == eGameplayState.play) {
                        // Pridat skore za gol
                        let pos = this._entity.getPosition();

                        gameplay.score += Gameplay.GOAL_SCORE;
                        (gameplay.scorePopups.activateItem() as TextPopup).show(pos.x, pos.y, Stadium.END_Z + 1, "+" + Gameplay.GOAL_SCORE);
                    }

                    this.setKickOffFinalRes(eKickOffResult.goal);
                }
            }
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private setKickOffFinalRes(res: eKickOffResult): void {
        /*let ballPos = this._entity.getPosition();
        let estimates = this._kickOffResEstimate;

        console.log("estimates | x: " + estimates.goalPos.x.toFixed(2) + " | y: " + (estimates.goalPos.y / Stadium.GOAL_HEIGHT).toFixed(2) + " z: " + estimates.goalPos.z.toFixed(2) + " | time: " + ((estimates.goalTime - this._kickOffTime) / 1000).toFixed(2));
        console.log("final | x: " + ballPos.x.toFixed(2) + " | y: " + (ballPos.y / Stadium.GOAL_HEIGHT).toFixed(2) + " | z: " + ballPos.z.toFixed(2) + " | time: " + ((TIMER.time - this._kickOffTime) / 1000).toFixed(2));
*/
        /*let tPos1 = estimates.targetPos;
        let tPos2 = TargetManager.instance.actTargets[0].pos;
        console.log("error: " + (tPos2.x - tPos1.x).toFixed(3) + "x" + (tPos2.y - tPos1.y).toFixed(3));
        tPos2 = TargetManager.instance.actTargets[0].getPositionInTime(estimates.goalTime);*/

        if (this._state = eBallState.controlledFlight)
            this._state = eBallState.uncontrolledFlight;

        if (this._kickOffFinalRes == eKickOffResult.none) {
            if ((this._kickOffFinalRes = res) == eKickOffResult.goal || res == eKickOffResult.target) {
                Game.playSound(eSfxSprite.goal + rnd2.randomIntIn(0, 1));
            }
            else {
                Game.playSound(eSfxSprite.miss + rnd2.randomIntIn(0, 2));

                // Zrusit Golden Ball
                if (this._fireBallState != 0) {
                    this._fireBallState = 0;
                    Gameplay.instance.events.fire(Ball.EVENT_FIRE_BALL_STATE_CHANGE, this._fireBallState);
                }
            }

            Gameplay.instance.events.fire(Ball.EVENT_FLIGHT_END, res);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    showMark(x: number | pc.Vec3, y?: number, z?: number): void {
        /*let mark = this._freeMarks.getItem();

        if (typeof x == "object") {
            mark.setPosition(x);
        }
        else {
            mark.setPosition(x, y, z);
        }

        mark.enabled = true;
        this._actMarks.push(mark);*/
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    clearMarks(): void {
        this._actMarks.forEach((mark: pc.Entity) => {
            mark.enabled = false;
            this._freeMarks.returnItem(mark);
        });
        this._actMarks.length = 0;
    }
}